<template>
  <ListItemPresenter
    :is-owner="isOwner"
    :is-nested="isNested"
    :items="visibleAnswers"
    :total-count="answersListTotalCount"
    :transition-enabled="transitionEnabled"
    @toggle-answers="toggleAnswers"
  >
    <template #header>
      <ListItemHeader
        :author="data.gmb_author"
        :date="data.gmb_create_time"
        :likes="data.upvote_count"
        :is-owner="isOwner"
      />
    </template>

    <template v-if="!isEditMode" #content>
      {{ data.text }}
    </template>

    <template #editActions>
      <ListItemEditActions
        v-if="isOwner"
        :is-nested="isNested"
        :value="data.text"
        @toggle-edit-mode="handleToggleEditMode"
        @update="handleUpdate"
        @delete="handleDelete"
        @cancel="handleCancel"
      />
    </template>

    <template #nestedItems="{ item }">
      <slot name="answers" :data="item" is-nested />
    </template>
    <template v-if="isLoading" #loader>
      <SkeletonLoader />
    </template>

    <template #publishActions>
      <ListItemPublishActions
        v-if="showPublishActions"
        @cancel="handleCancel"
        @publish="handlePublish"
      />
    </template>
    <template #companyCard>
      <CompanyCard
        :name="data.facility.name"
        :address="data.facility.formatted_address"
        :store-code="data.facility.store_code"
      />
    </template>
  </ListItemPresenter>
</template>

<script>
import ListItemHeader from "@/components/QuestionsAndAnswers/QaListItemHeader.vue";
import ListItemPresenter from "@/components/QuestionsAndAnswers/QaListItemPresenter.vue";
import ListItemPublishActions from "@/components/QuestionsAndAnswers/QaListItemPublishActions.vue";
import ListItemEditActions from "@/components/QuestionsAndAnswers/QaListItemEditActions.vue";
import SkeletonLoader from "@/components/QuestionsAndAnswers/QaListItemSkeletonLoader.vue";
import { Permission } from "@/enums/permission";
import { permissionCheck } from "@/helpers/permission-check";
import CompanyCard from "@/components/BusinessAddresses/StoreLocatorCompanyCard.vue";
import { AuthorType } from "@/enums/qa-gmb-author-type.js";
export default {
  name: "QaListItemContainer",
  components: {
    ListItemHeader,
    ListItemPresenter,
    ListItemPublishActions,
    ListItemEditActions,
    SkeletonLoader,
    CompanyCard
  },
  props: {
    isNested: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      answersExpanded: false,
      isEditMode: false,
      transitionEnabled: false
    };
  },
  computed: {
    showPublishActions() {
      return (
        !this.isNested &&
        !this.isOwnerInAnswersList &&
        !this.isLoading &&
        this.canAddAndEditQa &&
        !this.isEditMode
      );
    },
    canAddAndEditQa() {
      return permissionCheck(Permission.ADD_AND_EDIT_Q_AND_A);
    },

    answersList() {
      return this.data ? this.data.gmb_answers : null;
    },

    isOwner() {
      return this.data && this.data.gmb_author
        ? this.data.gmb_author.type === AuthorType.MERCHANT
        : false;
    },

    answersListTotalCount() {
      return this.answersList ? this.answersList.length : 0;
    },
    isOwnerInAnswersList() {
      return this.answersList.some(
        answer => answer.gmb_author.type === AuthorType.MERCHANT
      );
    },

    visibleAnswers() {
      if (!this.answersList) return null;

      return this.answersExpanded
        ? this.answersList
        : this.answersList.slice(0, 2);
    }
  },
  methods: {
    toggleAnswers(answersExpanded) {
      this.answersExpanded = answersExpanded;
    },
    handlePublish(data) {
      this.$emit("publish", data);
      this.transitionEnabled = true;
    },
    handleUpdate(data) {
      this.$emit("update", data);
      this.transitionEnabled = true;
      this.isEditMode = false;
    },
    handleDelete(id) {
      this.$emit("delete", id);
    },
    handleToggleEditMode() {
      this.transitionEnabled = false;
      this.isEditMode = true;
    },
    handleCancel() {
      this.isEditMode = false;
    }
  }
};
</script>
